import {
  useState,
  useRef,
  FormEvent,
  useCallback,
  useMemo,
  useEffect,
} from 'react';

import { FiSearch } from 'react-icons/fi';
import { IoIosArrowBack } from 'react-icons/io';
import { MdFilterList } from 'react-icons/md';
import { useHistory } from 'react-router-dom';
import { MoonLoader } from 'react-spinners';
import { toast } from 'react-toastify';

import { Layout } from '~/components';
import { PowerCreator } from '~/models/PowerCreator';
import api from '~/services/api';

import { Card } from './Card';
import Modal from './Modal';

import {
  ModalTitle,
  CheckboxWrapper,
  ModalButton,
  Header,
  Container,
  HeaderWrapper,
  HeaderLabel,
  PageHeader,
  ContentRight,
  InputContainer,
  CardContainer,
  CheckButton,
  CheckboxSet,
  AlertContainer,
} from './styles';

type PowerCreatorsRequestData = {
  data: PowerCreator[];
};

function MetLibraryArchive() {
  const { goBack } = useHistory();

  const searchRef = useRef<HTMLInputElement>(null);

  const [loading, setLoading] = useState(false);
  const [modalFilterIsOpen, setModalFilterIsOpen] = useState(false);
  const [selectedMethodBox, setSelectedMethodBox] = useState<number>();
  const [metLibraries, setMetLibraries] = useState<PowerCreator[]>([]);

  // load libraries
  const loadLibraries = useCallback(async () => {
    const { data } = await api.get<PowerCreatorsRequestData>('power-creators', {
      params: {
        filed: true,
      },
    });

    setMetLibraries(data.data);

    setLoading(false);
  }, []);

  useEffect(() => {
    setLoading(true);
    loadLibraries();
  }, [loadLibraries]);

  const checkBoxMethodOptions = useMemo(() => {
    return [
      { id: 1, label: '2 tempos' },
      { id: 2, label: '3 tempos' },
      { id: 3, label: 'breakdown' },
      { id: 4, label: 'bulk' },
      { id: 5, label: 'bombear' },
      { id: 6, label: 'cadência 40 20' },
      { id: 7, label: 'carga progressiva' },
      { id: 8, label: 'carga regressiva' },
      { id: 9, label: `don't stop` },
      { id: 10, label: 'propset' },
      { id: 11, label: 'escada' },
      { id: 12, label: 'flushing' },
      { id: 13, label: 'FST' },
      { id: 14, label: 'inundação' },
      { id: 15, label: 'isodinâmico' },
      { id: 16, label: 'numbness' },
      { id: 17, label: 'oxford' },
    ];
  }, []);

  const CheckBoxMethod = useMemo(
    () =>
      checkBoxMethodOptions.map((item) => (
        <CheckButton
          key={item.id}
          isSelected={selectedMethodBox === item.id}
          onClick={() => setSelectedMethodBox(item.id)}
        >
          <div className="radio">
            <div className="filled" />
          </div>

          <p>{item.label}</p>
        </CheckButton>
      )),
    [checkBoxMethodOptions, selectedMethodBox],
  );

  const handleSearch = useCallback(async (e: FormEvent) => {
    console.log(e);
  }, []);

  const deleteLibrary = useCallback(
    async (id) => {
      try {
        await api.delete(`power-creators/${id}`);

        const filteredLibraries = metLibraries.filter(
          (library) => library.id !== id,
        );

        setMetLibraries(filteredLibraries);

        toast.success(`Método deletado com sucesso!`);
      } catch (err) {
        toast.error(`Ocorreu um erro ao tentar deletar o método!`);
      }
    },
    [metLibraries],
  );

  const restoreLibrary = useCallback(
    async (id) => {
      try {
        await api.post(`power-creators/${id}`, {
          action: 'unarchive',
        });

        const filteredLibraries = metLibraries.filter(
          (library) => library.id !== id,
        );

        setMetLibraries(filteredLibraries);

        toast.success(`Método restaurado com sucesso!`);
      } catch (err) {
        toast.error(`Ocorreu um erro ao tentar restaurar o método!`);
      }
    },
    [metLibraries],
  );

  function ModalFilter() {
    return (
      <Modal
        isOpen={modalFilterIsOpen}
        setOpen={setModalFilterIsOpen}
        maxWidthStyled={621}
        maxHeightStyled={736}
      >
        <ModalTitle>Filtrar</ModalTitle>

        <CheckboxWrapper>
          <span>Métodos:</span>
          <CheckboxSet className="set">{CheckBoxMethod}</CheckboxSet>
        </CheckboxWrapper>

        <ModalButton>Aplicar</ModalButton>
      </Modal>
    );
  }

  return (
    <Layout title="I.LAB">
      <Header>
        <HeaderWrapper onClick={() => goBack()}>
          <IoIosArrowBack color="#FFDF22" size={24} />
          <HeaderLabel>Arquivo</HeaderLabel>
        </HeaderWrapper>
      </Header>

      <Container>
        <PageHeader>
          <ModalFilter />

          <ContentRight>
            <InputContainer>
              <form onSubmit={handleSearch}>
                <FiSearch size={30} color="#000" />

                <input
                  type="text"
                  placeholder="Buscar por aluno"
                  name="search"
                  id="search"
                  ref={searchRef}
                />

                <MdFilterList
                  size={30}
                  color="#000"
                  onClick={() => setModalFilterIsOpen(true)}
                />
              </form>
            </InputContainer>
          </ContentRight>
        </PageHeader>

        {loading ? (
          <AlertContainer>
            <MoonLoader size={30} color="#FFDF22" />
          </AlertContainer>
        ) : (
          <CardContainer>
            {metLibraries.map((library) => (
              <Card
                key={library.id}
                data={library}
                deleteData={deleteLibrary}
                restoreData={restoreLibrary}
              />
            ))}
          </CardContainer>
        )}
      </Container>
    </Layout>
  );
}

export default MetLibraryArchive;
